const endorsementType = [
  {
    text: 'Name Change',
    value: 'NameChange',
    id: '1',
  },
  {
    text: 'Change Designated Officer/Contact Person',
    value: 'ChangeDesignatedOfficerContactPerson',
    id: '42',
  },
  {
    text: 'Mailing Address Change',
    value: 'MailingAddressChange',
    id: '2',
  },
  {
    text: 'Policy Limit Change',
    value: 'PolicyLimitChange',
    id: '10',
  },
  {
    text: 'Coverage Retention Change',
    value: 'CoverageRetentionChange',
    id: '41',
  },
  {
    text: 'Add/Remove/Change Directors & Officers Coverage',
    value: 'DirectorsOfficersCoverageChange',
    id: '37',
  },
  {
    text: 'Add/Remove/Change Employment Practices Coverage',
    value: 'EmploymentPracticesCoverageChange',
    id: '38',
  },
  {
    text: 'Add/Remove/Change Fiduciary Coverage',
    value: 'FiduciaryCoverageChange',
    id: '39',
  },
  {
    text: 'Add/Remove/Change Crime Coverage',
    value: 'CrimeCoverageChange',
    id: '40',
  },
  {
    text: 'Other - Misc',
    value: 'Other',
    id: '9',
  },
];

export default endorsementType;
